import { DEFAULT_LANGUAGE } from '@cibli/shared';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useCVTemplateContext } from '@/features/common/contexts/cv-template.context';

/**
 * Hook pour traduire les textes du CV avec la locale CV spécifique
 */
export const useCVTranslation = () => {
  const { t, i18n } = useTranslation();
  const { currentLocaleCv } = useCVTemplateContext();
  const locale = currentLocaleCv ?? DEFAULT_LANGUAGE;

  // Fonction pour traduire avec la locale CV
  const tWithLocale = useCallback(
    (key: string, options?: Record<string, unknown>) => {
      return t(key, { ...options, lng: locale });
    },
    [t, locale],
  );

  // Fonction pour formater les dates avec la locale CV
  const formatDate = useCallback(
    (dateString: string, options?: Intl.DateTimeFormatOptions) => {
      if (!dateString || dateString === 'CURRENT') return '';
      // Year alone (e.g. "2021"): display as-is, never fabricate a month
      if (/^\d{4}$/.test(dateString)) return dateString;
      // Try direct parse first (handles YYYY-MM-DD, YYYY-MM, ISO strings)
      let date = new Date(dateString);
      // If invalid, try prepending day for YYYY-MM format
      if (isNaN(date.getTime()) && /^\d{4}-\d{2}$/.test(dateString)) {
        date = new Date(dateString + '-01');
      }
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString(locale, options);
    },
    [locale],
  );

  return { t: tWithLocale, formatDate, currentLocaleCv, i18n };
};
